import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";
import Input from "../../components/input";
import { sportAdd, uploadCms } from "../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Loader from "../../components/loader";

const EditSportModal = ({
  isEditOpen,
  closeEditModal,
  fetchSportsList,
  selectedSportId,
}) => {
  const [sport, setSport] = useState("");
  const [icon, setIcon] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { auth } = useSelector((state) => state.login);
  const { sports } = useSelector((state) => state.sports);

  useEffect(() => {
    const selectedSport = sports?.find(
      (sport) => sport?.id === selectedSportId
    );
    setSport(selectedSport?.sportName || "");
    setIcon(null);
  }, [selectedSportId]);

  const handleEditSport = async () => {
    if (!sport) {
      setError("This field is required");
      return;
    }

    let fileName = "";
    if (icon) {
      const formData = new FormData();
      formData.append("file", icon);
      try {
        setLoading(true);
        const uploadResponse = await axios.post(uploadCms, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (uploadResponse.status === 200) {
          fileName = uploadResponse.data.message;
          fileName = fileName?.split("/")?.pop();
        }
      } catch(error) {
        toast.error("Error uploading icon")
        console.error("Error uploading icon", error);
        return;
      } finally {
        setLoading(false)
      }
    }
    const body = {
      sportName: sport,
      icon: icon ? fileName : null,
    };

    try {
      setLoading(true);
      const response = await axios.post(sportAdd, body, {
        params: {
          id: selectedSportId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      });
      if (response?.status == 200) {
        toast.success(response?.data?.message);
        handleClose();
        fetchSportsList();
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSport("");
    setIcon(null);
    setError("");
    closeEditModal();
  };

  return (
    <>
      {loading && <Loader />}
      <Modal show={isEditOpen} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Sport</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Input
              label="Sport Icon"
              type="file"
              accept="image/png, image/jpeg"
              value={icon}
              onChange={(e) => setIcon(e.target.files[0])}
              className="mb-3"
            />
            <Input
              label="Sport Name"
              type="text"
              placeholder="Sport Name"
              value={sport}
              onChange={(e) => setSport(e.target.value)}
            />
            {error && <div className="text-danger">* {error}</div>}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button text="Edit Sport" callBack={handleEditSport} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditSportModal;
